<template>
  <div class='at-infobox mt-0 form-styled-3 player-settings-page'>
    <form>
      <div class="form-group mb-5">
        <span class="text-white d-block heading-3 ">Subtitle</span>
        <el-radio v-model="subtitle_size" :label="s" class="mt-3" 
          @change="update('subtitle_size')"
          v-for="s in subtitles"
          :key=s
        >
          {{ s }}
        </el-radio>
      </div>

      <div class="form-group mb-5">
        <span class="text-white d-block heading-3 ">
          Subtitle Font Color
        </span>
        <el-radio v-model="subtitle_color" :label="c" 
          :class="'mt-3 text-' + c" 
          @change="update('subtitle_color')"
          v-for="c in fontColors"
          :key=c
        >
          {{ c }}
        </el-radio>
      </div>
    </form>
  </div>
</template>


<script>
import { authRequest } from '../../app/helpers';
import toastr from 'toastr';

export default {
  data() {
    return {
      subtitles: [12, 14, 16, 18],
      subtitle_color: '',
      fontColors: ['yellow', 'white', 'red'],
      subtitle_size: ''
    }
  },


  mounted() {
    this.getSettings();
  },


  methods: {
    async getSettings() {
      const req = await authRequest(
        this.$router,
        '/user/player_settings'
      );

      const reqKeys = Object.keys(req);

      for (const i in reqKeys) {
        const element = reqKeys[i];
        
        this.$data[element] = req[element];
      }
    },

    async update(option) {
      const value = this.$data[option];

      const req = await authRequest(
        this.$router, 
        '/user/site_setting/' + option, 
        { value }, 
        'post'
      );

      if (req.status) {
        toastr.success(req.message);
      } else {
        toastr.error(req.message);
      }
    },
  }
}
</script>


<style lang="scss">
.player-settings-page .el-radio__label {
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
}

.player-settings-page {
  .text-red { color: red; }
  .text-yellow { color: yellow; }
  .text-white { color: white; }
}
</style>